<template>
    <div>
        <v-card
            variant="tonal"
            max-width="500"
            max-height="700"
            class="rounded-xl"
            elevation="9"
        >
            <v-sheet>
                <div>
                    <div
                        style="
                            font-size: 23px;
                            font-weight: bold;
                            color: #242939;
                            margin: 13px;
                        "
                    >
                        Phone List:
                        <span style="font-size: 15px">
                            Lookup extension by name</span
                        >
                    </div>
                </div>
            <v-divider></v-divider>
                <v-row class="mb-1">
                    <v-col>
                        <div>
                            <v-text-field
                                prepend-icon="fa-solid fa-phone"
                                variant="underlined"
                                label="Search Name"
                                class="mx-auto"
                                style="max-width: 20rem"
                                clearable
                                v-model="table.search.value"
                                @click:clear="onClearClicked_Search"
                            ></v-text-field>
                        </div>
                    </v-col>
                </v-row>

                <v-container fluid max-height="400" max-width="400">
                    <div
                        id="table"
                        class="d-flex flex-column"
                        v-if="table.search.value"
                    >
                        <Vue3EasyDataTable
                            buttons-paginaton
                            class="customize-table"
                            header-text-direction="center"
                            body-text-direction="center"
                            :headers="table.header"
                            :items="table.extensions"
                            :search-field="table.search.columns"
                            :search-value="table.search.value"
                            :rows-per-page="10"
                            :table-height="200"
                            :table-width="200"
                        ></Vue3EasyDataTable>
                    </div>
                </v-container>
            </v-sheet>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import Vue3EasyDataTable from "vue3-easy-data-table";

export default {
    name: "PhoneListComponent",
    components: {
        Vue3EasyDataTable,
    },
    data() {
        return {
            loading: false,
            table: {
                header: [
                    { text: "Name", value: "NAME" },
                    { text: "Extension", value: "Extension" },
                ],
                extensions: [],
                search: {
                    value: "",
                    columns: ["NAME"],
                },
            },
        };
    },
    mounted() {
        this.fetchRecords();
    },
    methods: {
        fetchRecords() {
            this.loading = true;
            this.table.extensions = [];
            axios
                .get(route("api.resources-phone-list.index"))
                .then((response) => {
                    this.table.extensions = response.data.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onClearClicked_Search() {
            this.table.search.value = "";
        },
    },
};
</script>

<style scoped>
.customize-table {
    --easy-table-header-font-size: 15px;
    --easy-table-header-font-color: #242939;
    --easy-table-header-background-color: #eee;
    --easy-table-header-font-color: #242939;

    --easy-table-body-row-height: 63px;
    --easy-table-body-row-font-size: 16px;

    --easy-table-footer-background-color: #ffffff;
    --easy-table-footer-font-color: #242939;
    --easy-table-footer-font-size: 15px;
    --easy-table-footer-padding: 0px 10px;
    --easy-table-footer-height: 55px;

    --easy-table-rows-per-page-selector-width: 75px;
    --easy-table-rows-per-page-selector-option-padding: 15px;

    --easy-table-body-row-hover-background-color: #eee;

    --easy-table-loading-mask-background-color: #ffffff;
}
</style>
